export const PERSON_ID = 'PERSON_ID';
export const PERSON = 'PERSON';
export const EVENTS = 'EVENTS';
export const PAGINATION = 'PAGINATION';
export const DIALOG_PERSON_UNSUBSCRIBE_VISIBILITY = 'DIALOG_PERSON_UNSUBSCRIBE_VISIBILITY';
export const DIALOG_PERSON_LEAD_SCORE_RESET_VISIBILITY = 'DIALOG_PERSON_LEAD_SCORE_RESET_VISIBILITY';
export const GENERAL_ERRORS = 'GENERAL_ERRORS';
export const RESET = 'RESET';
